export default {
  default: {
    labelIntegration: 'Integration',
    description: 'Integration Platform',
  },
}
